var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WideStaticNotice',{attrs:{"text":_vm.alertText,"button-text":_vm.buttonText,"is-drawn-button":"","is-align-center-on-pc":""},on:{"click-button":_vm.navigateToContactForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }